import React, { useCallback } from 'react';

import styled from '@emotion/styled';

import StarFillIcon from '../Icons/StarFillIcon';
import StarOutlineICon from '../Icons/StarOutlineICon';

interface StarsProps {
  numStars?: number;
  data?: Record<string, any>;
  dataKey?: string;
  fillOnly?: boolean;
}

const Stars: React.FC<StarsProps> = ({ numStars, data, dataKey, fillOnly }) => {
  const arr = useCallback(() => {
    const maxStars = 5;
    const starsArray = new Array(maxStars).fill(1);
    starsArray.fill(0, numStars || data?.[dataKey ?? ''] || 0);
    return starsArray;
  }, [numStars, data, dataKey])();

  return (
    <Container>
      {arr.map((num, index) => {
        return num === 1 ? (
          <StarFillIcon key={index} />
        ) : fillOnly ? null : (
          <StarOutlineICon key={index} />
        );
      })}
    </Container>
  );
};

export default Stars;

const Container = styled.div`
  /* border: 1px solid red; */
  display: grid;
  grid-template-columns: repeat(5, auto);
  max-width: fit-content;
  gap: 2px;
`;
